const initialState = { isLoading: true, autocomplete: [], requestMake: false };
export const FETCH_AUTOCOMPLETE = 'FETCH_AUTOCOMPLETE';
export const FETCH_AUTOCOMPLETE_SUCCESS = `${FETCH_AUTOCOMPLETE}_SUCCESS`;
export const FETCH_AUTOCOMPLETE_FAIL = `${FETCH_AUTOCOMPLETE}_FAIL`;

const AutocompleteReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_AUTOCOMPLETE:
      return { ...state, isLoading: true, requestMake: true };
    case FETCH_AUTOCOMPLETE_SUCCESS:
      return { ...state, isLoading: false, autocomplete: action.payload.data };
    case FETCH_AUTOCOMPLETE_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return { ...state };
  }
};

export default AutocompleteReducer;
